import { Booster, BoosterApi, BoosterStatus } from "../types/Booster";

const formatBoosterB2F = (booster: BoosterApi): Booster => ({
  boosterId: booster.boosterId,
  factor: booster.multiplier,
  duration: 100,
  expiredTime: booster.expireAt,
  gameId: booster.gameId,
  boosterGame: {
    name: "",
  },
});

export const formatBoosters = (boosters?: BoosterApi[]) => {
  if (!boosters) {
    return {
      activeBooster: null,
      availableBooster: null,
      secondAvailableBooster: null,
    };
  }

  const activeBooster = boosters.find(
    (booster) => booster.status === BoosterStatus.Active,
  );

  if (activeBooster) {
    return {
      activeBooster: formatBoosterB2F(activeBooster),
      availableBooster: null,
      secondAvailableBooster: null,
    };
  }

  const sortedAvailableBoosters = boosters
    .filter((booster) => booster.status === BoosterStatus.Available)
    .sort((a) => new Date(a.expireAt).valueOf() - new Date().valueOf());

  return {
    activeBooster: null,
    availableBooster: sortedAvailableBoosters?.[0]
      ? formatBoosterB2F(sortedAvailableBoosters?.[0])
      : null,
    secondAvailableBooster: sortedAvailableBoosters?.[1]
      ? formatBoosterB2F(sortedAvailableBoosters?.[1])
      : null,
  };
};
